import { FC, useEffect, useState } from "react"
import * as Yup from "yup"
import { Form, Formik } from "formik"
import AuthServices from "@lib/api/services/auth.services"
import { setCookie } from "nookies"
import { calculateAge, domainChecker } from "@lib/functions"
import { Modal, ModalProps } from "@components/modal"
import { GoogleLoginButton, RegularButton } from "@components/button"
import { FormikInput, PasswordInput } from "@components/input"
import { FlexBox } from "@components/wrapper"
import { trackCustomEvent } from "@utils/analytics"
// import { useAnalytics } from "@lib/context/AnalyticsContext"

export interface LoginModalProps extends ModalProps {
  redirect?: string
}

export const LoginModal: FC<LoginModalProps> = ({ show, onClose, redirect, ...props }) => {
  const [validation, setValidation] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [validationRequired, setValidationRequired] = useState(false)

  useEffect(() => {
    if (!show) {
      setValidation("")
    }
  }, [show])

  const auth = new AuthServices()
  // const { analytics } = useAnalytics()

  const validationSchema = Yup.object({
    email: Yup.string().email("Email tidak valid").required("Email harus diisi"),
    password: Yup.string().required("Password harus diisi"),
  })

  function errorMessageGenerator(msg: string) {
    setValidation(msg)
  }

  return (
    <Modal {...props} show={show} onClose={onClose} contentClassName="!p-0 sm:w-[30%]">
      <div className="pt-5 font-semibold text-center text-2xl">Login</div>

      <div className="pt-[30px] px-[30px]">
        <GoogleLoginButton handleError={errorMessageGenerator} redirect={redirect} />
        <div className="h-3 my-10 text-center border-b-grey-97 border-b">
          <span className="bg-white px-3.5">atau</span>
        </div>

        <Formik
          initialValues={{ email: "", password: "" }}
          validationSchema={validationSchema}
          validateOnChange={validationRequired}
          validateOnBlur={validationRequired}
          onSubmit={async (value) => {
            setValidation("")
            setIsLoading(true)
            try {
              const res = await auth.manualLogin(value)

              if (res.isFailure) {
                const err = res.error
                setValidation(err.message)
                return setIsLoading(false)
              }

              const result = res.getValue()
              const userData = result.data

              if (result.data.status_completed_profile) {
                // analytics.identify(userData.id, {
                //   address: {
                //     city: "",
                //     country: "Indonesia",
                //     postalCode: "",
                //     state: "",
                //   },
                //   age: calculateAge(userData.user_birthday as Date),
                //   avatar: userData.user_picture,
                //   birthday: new Date(userData.user_birthday as Date),
                //   email: userData.user_email,
                //   firstName: userData.user_firstname,
                //   gender: userData.user_gender == 1 ? "Male" : "Female",
                //   lastName: userData.user_lastname,
                //   name: userData.fullname,
                //   phone: userData.user_phone_number,
                // })

                // analytics.track("Signed In", {
                //   method: "email",
                // })

                if (!redirect) {
                  window.location.reload()
                } else {
                  window.location.assign(redirect)
                }
              } else {
                setCookie(null, "HS_TEMP", JSON.stringify(result.data), {
                  path: "/",
                  domain: domainChecker(),
                })

                window.location.assign("/biodata")
              }

              trackCustomEvent("login", {
                method: "email",
                user_id: result.data.user_id,
              })
            } catch (e: any) {
              console.log(e)
              setValidation("Terjadi kesalahan. Cek kembali data yang diinput dan coba lagi")
              setIsLoading(false)
            }
          }}
        >
          <Form>
            <FormikInput placeholder="Masukkan e-mail kamu" name="email" className="mb-6" />

            <PasswordInput placeholder="Masukkan password kamu" name="password" className="mb-6" />

            <RegularButton
              className="mt-6 w-full py-3.5 rounded"
              isSubmitting={isLoading}
              onClick={() => setValidationRequired(true)}
              isFormik
            >
              Masuk
            </RegularButton>
          </Form>
        </Formik>

        <div className="mt-2.5 text-red">{validation}</div>
        <div className="mt-4 mb-5 text-center">
          <a href={"/lupa-password"} className="text-green font-semibold text-center">
            Lupa Password?
          </a>
        </div>
      </div>

      <FlexBox className="p-6 border-t-[#dee2e6] border-t" justify="center">
        Belum bergabung?{" "}
        <a href={`/register`} className="ml-1.5 text-green font-semibold">
          Daftar Akun
        </a>
      </FlexBox>
    </Modal>
  )
}
